import { Card } from '../../common/Card';

export const LayerControl = ({ activeCategories, onToggle }) => {
  const layers = [
    { id: 'minerals', name: 'الموارد المعدنية', icon: '🪨', color: '#f59e0b' },
    { id: 'energy', name: 'مصادر الطاقة', icon: '⚡', color: '#38bdf8' },
    { id: 'agriculture', name: 'الزراعة', icon: '🌾', color: '#34d399' },
    { id: 'tourism', name: 'السياحة', icon: '🏛️', color: '#fb7185' }
  ];

  return (
    <Card className="p-4 map-panel-card">
      <h3 className="text-lg font-black mb-3 flex items-center gap-2 text-gray-900">
        <span>🧠</span>
        اختر نوع الموارد
      </h3>
      <div className="space-y-2">
        {layers.map((layer) => {
          const isActive = activeCategories.includes(layer.id);
          return (
            <label
              key={layer.id}
              className={`map-choice-row ${isActive ? 'map-choice-row-active' : ''}`}
            >
              <input
                type="checkbox"
                checked={isActive}
                onChange={() => onToggle(layer.id)}
                className="w-5 h-5"
              />
              <span className="text-2xl">{layer.icon}</span>
              <span className="flex-1 font-bold text-gray-900">{layer.name}</span>
              <div
                className="w-4 h-4 rounded-full shadow-inner"
                style={{ backgroundColor: layer.color }}
              />
            </label>
          );
        })}
      </div>
    </Card>
  );
};
